module.exports = __webpack_public_path__ + "static/media/uzbekistn.dcb9a177.svg";